var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timeout_info"},[_c('van-overlay',{attrs:{"show":_vm.infoShow}},[_c('div',{staticClass:"timeout_info_wrapper"},[_c('div',{staticClass:"timeout_info_wrapper_pic"},[_vm._v(" 提示 ")]),_c('p',[_vm._v(_vm._s(_vm.infoMsg))]),_c('div',{staticClass:"timeout_info_wrapper_btns",on:{"click":_vm.goback}},[_vm._v(" 我知道啦 ")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }